export const productName = 'MEGAPACK INSTRUMENTACIÓN QUIRÚRGICA LISTO™';
export const productImage = 'https://cdn.magicpatterns.com/uploads/46FZwEv4g9Tf1NmMnnwAaT/MOCKUP.png';

export const baseUrl = 'https://emprendepackcentral.store/cart/48599954424002:1';
export const premiumUrl = 'https://emprendepackcentral.store/cart/48599955669186:1';

export const baseItems = [
  'TOMO 1: Fundamentos de la Instrumentación Quirúrgica',
  'TOMO 2: Instrumental Quirúrgico Completo',
  'TOMO 3: Instrumentación por Especialidades Quirúrgicas',
  'TOMO 4: Organización del Quirófano y Procedimientos',
  'TOMO 5: Prácticas Profesionales y Simulación Clínica',
  'TOMO 6: Planificación Docente 2026',
  'BONO 1: Banco de 300 Exámenes Multiformato',
  'BONO 2: 150 Casos Clínicos Resueltos',
  'BONO 3: Kit Docente Editable Completo',
  'BONO 4: Fichas Técnicas e Imágenes Descriptivas',
  'Acceso de por vida y actualizaciones gratuitas',
];

export const premiumItems = [
  'UPSELL 1 — Cirugía Avanzada y Alta Complejidad: robótica Da Vinci, trasplante, oncológica radical, HIPEC, sala híbrida, TAVI, EVAR y tecnología quirúrgica 2026',
  'UPSELL 2 — Biblioteca Premium de Referencia Profesional: atlas anatómico, farmacología del quirófano, anestesiología, suturas, implantes, legislación y diccionario de 500+ términos',
  'Normas y estándares internacionales AORN / ISO / JCI actualizados 2026',
  'Indicadores de calidad quirúrgica, ciclo PDCA y gestión del área',
  'Catálogo de implantes con trazabilidad y normativa ANMAT 2026',
  'Acceso de por vida y actualizaciones gratuitas',
];

export const checklist: Array<[string, string]> = [
  ['Contenido 100% argentino', 'INET, AAIQ, ANMAT, Ley 26.058, Ministerio de Salud, protocolos OMS adaptados y diseños curriculares provinciales.'],
  ['Material imprimible', 'Listo para usar en el aula o entregar directamente al alumno.'],
  ['Formularios y protocolos reales', 'Checklist OMS, conteo quirúrgico, trazabilidad y evento adverso adaptados a Argentina 2026.'],
  ['Casos resueltos paso a paso', 'Con datos reales de la práctica quirúrgica argentina.'],
  ['Vocabulario técnico explicado', 'Sin tecnicismos innecesarios para el nivel del aula.'],
  ['Conexión con la actualidad', 'Cirugía robótica, sala híbrida, TAVI, bariátrica, trasplante y protocolos 2026.'],
  ['Historia y contexto argentino', 'Desde los orígenes de la profesión hasta las competencias del INET 2026.'],
  ['4 bonos estratégicos', 'Evaluaciones, casos clínicos, kit docente y fichas técnicas.'],
  ['Garantía de 7 días', 'Sin preguntas ni formularios.'],
  ['Acceso inmediato', 'Descarga directa tras la compra, con actualizaciones gratuitas de por vida.'],
];
